/**
 * @description 首页排行榜
 * @author Kody
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface ILearnerParam {
    page: number;
    size: number;
    days: number;
    type: number;
}

export interface ILearnerOutput {
    profile_url: string;
    user_level: number;
    show_user_level: number;
    avatar: string;
    user_name: string;
    user_medal: IUserMedal;
}

export function getLearnerList(data: ILearnerParam): Promise<IListResponse<ILearnerOutput>> {
    return fetchData(Api.GET_LEARNER_LIST, data).then((res: IListResponse<ILearnerOutput>) => {
        return res;
    });
}
